<template>
  <div>
    <a-modal
      @ok="prePrintBulletin"
      @cancel="closeModal"
      v-model="visibleFinalBulletin"
      :title="$t('bulletin.finalBulletin')"
      :closable="false"
      :width="700"
      :height="700"
      :key="'bulletinDate'"
    >
      <div>
        <a-form layout="vertical">
          <!-- date picker -->
          <div class="row mt-2">
            <div class="col-5 d-flex align-items-center">
              <label>{{ $t("bulletin.date") }}</label>
            </div>
            <div class="col d-flex justify-content-between align-items-center">
              <a-form-item class="m-0 flex-grow-1 mr-4">
                <a-date-picker
                  :allowClear="false"
                  @change="
                    (val) => {
                      bulletinDate = val;
                    }
                  "
                  :value="bulletinDate || moment(new Date())"
                  :disabled="!showDate"
                  format="DD/MM/YYYY"
                  style="width: 100%"
                />
              </a-form-item>
              <a-form-item class="m-0">
                <a-switch v-model="showDate" />
              </a-form-item>
            </div>
          </div>

          <!-- stamp switch -->
          <div class="row mt-2">
            <div class="col-5 d-flex align-items-center">
              <label>{{ $t("bulletin.showStamp") }}</label>
            </div>
            <div class="col">
              <a-form-item class="m-0">
                <a-switch v-model="showStamp" />
              </a-form-item>
            </div>
          </div>

        </a-form>
      </div>
    </a-modal>
  </div>
</template>

<script>
/*eslint-disable */
import moment from "moment";
import apiClient from "@/services/axios";
import { mapState } from "vuex";
import JsPDF from "jspdf";

export default {
  props: [
    "visibleFinalBulletin",
    "selectedTrimester",
    "studentID",
    "classroomID",
    "config",
    "type",
    "level",
  ],
  data() {
    return {
      bulletinDate: null,
      teachers: [],
      selectedTeachers: [],
      schoolDetails: {},
      schoolarYearName: ".... / ....",
      bulletin: {},
      showStamp: true,
      stampScale: 1,
      showDate: true,
      showNbrStudents: true,
      showUniqueIDen:false
    };
  },
  computed: {
    ...mapState(["settings", "user"]),
  },
  components: {},
  watch: {
    visibleFinalBulletin(newVal) {
      if (newVal) {
        this.bulletinDate = null;
        this.fetchConfig();
        this.fetchTeachers();
      }
    },
    classroomID: {
      handler: "fetchTeachers",
      immediate: true,
    },
    selectedTrimester: {
      handler: "fetchTeachers",
      immediate: true,
    },
  },
  async created() {
    this.schoolDetails = this.user.building.filter(
      (el) => el.dbName == this.settings.activeBuilding
    )[0];
    let { start, end } = this.settings.schoolarYears.find(
      (el) => el._id == this.settings.activeSchoolarYear
    );

    start = new Date(start).getFullYear();
    end = new Date(end).getFullYear();

    this.schoolarYearName = end + " / " + start;
    this.fetchTeachers();
  },
  methods: {
    moment,
    // Annual report config (per type + level) replaces the old in-modal switches.
    // Stamp/date stay as one-shot print overrides, pre-filled from the config.
    async fetchConfig() {
      // defaults if no saved config or fetch fails
      this.showNbrStudents = true;
      this.showStamp = true;
      this.stampScale = 1;
      this.showDate = true;
      if (!this.type || this.level === undefined || this.level === null) return;
      try {
        const { data } = await apiClient.get(
          `/bulletin/v2/annual-report-config/${this.type}/${this.level}`
        );
        this.showNbrStudents = data.showNbrStudents !== false;
        this.showStamp = data.showStamp !== false;
        this.stampScale = data.stampScale ?? 1;
        this.showDate = data.showDate !== false;
        // ensure backward comp
        this.showUniqueIDen = (data.showUniqueIDen != null || data.showUniqueIDen != undefined) && data.showUniqueIDen !== false        
      } catch (error) {
        console.error("Failed to load annual report config", error);
      }
    },
    async fetchTeachers() {
      this.teachers = [];
      this.selectedTeachers = [];
      if (!this.classroomID) {
        return;
      }
      try {
        const [teachersRes, selectedTeachersRes] = await Promise.all([
          apiClient.get(`/teacherAccess/3`),
          apiClient.get(
            `/bulletin/v2/annual-teacher-selection/${this.classroomID}`
          ),
        ]);

        this.teachers = teachersRes.data.filter((teacher) =>
          teacher.access.some(
            (accessItem) => accessItem.classeRoom._id === this.classroomID
          )
        );

        if (selectedTeachersRes.data && selectedTeachersRes.data.teachers) {
          this.selectedTeachers = selectedTeachersRes.data.teachers.map(
            (teacher) =>
              typeof teacher === "object" ? teacher._id || teacher : teacher
          );
        }
      } catch (error) {
        this.teachers = [];
        this.selectedTeachers = [];
      }
    },
    closeModal() {
      this.$emit("closeFinalBulletin");
      this.$emit("printLoading", false);
    },
    async prePrintBulletin() {
      this.closeModal();
      this.$emit("printLoading", true);
      try {
        const res = await apiClient.get(
          `/bulletin/v2/bt/yearly/3/${this.type}/${this.studentID}`
        );
        this.bulletin = res.data;
        await this.printBulletin();
      } catch (error) {
        console.error("Failed to print annual bulletin:", error);
        this.$emit("printLoading", false);
      }
    },

    async printBulletin() {
      const doc = new JsPDF();
      const ctx = doc.context2d;
      const pdf_width = doc.internal.pageSize.width;
      let text;
      let width = 0;
      let currentY = 10;
      // background header
      const img = new Image();
      img.src = "./resources/images/bg1.png";
      doc.addImage(img, "png", 0, 0, pdf_width, 37);

      //stamp
      let stamp = this.settings.resourcesUrl.replace(
        "FILE_PATH",
        this.schoolDetails.stamp
      );
      const stampImage = new Image(30);
      if (stamp) stampImage.src = stamp;
      if (stamp) {
        try {
          await this.waitLoadingImage(stampImage);
        } catch (e) {}
      }
      //end stamp
      // Header texts

      doc.setFont("Amiri", "Bold");
      doc.setFontSize(14);
      doc.setTextColor(99, 87, 91);
      text = "الجمهورية التونسية";
      width = doc.getTextWidth(text);
      doc.text(text, pdf_width - width - 10, currentY);
      currentY += 8;

      doc.setFont("PT Bold Heading", "Bold");
      doc.setFontSize(13);
      text = "وزارة التربية";

      width = doc.getTextWidth(text);
      doc.text(text, pdf_width - width - 15, currentY);

      // Header texts
      //doc.setFont("PT Bold Heading", "Bold");
      //doc.setFontSize(13);
      //text = "المندوبيّة الجهويّة للتربيّة";
      //doc.setTextColor(99, 87, 91);
      //width = doc.getTextWidth(text);
      //doc.text(text, pdf_width - width - 15, 12);
      //console.log(this.schoolDetails);
      doc.setFont("PT Bold Heading", "Bold");
      doc.setFontSize(13);
      text = "المندوبيّة الجهويّة للتربيّة";
      text += this.schoolDetails.delegeRegional
        ? " بـ " + this.schoolDetails.delegeRegional
        : ".....................................بـ ";
      width = doc.getTextWidth(text);
      doc.text(text, 105 - width - 15, currentY);
      currentY += 8;
      doc.setFont("Amiri", "normal");

      doc.setTextColor(67, 62, 63);
      doc.setFontSize(12);
      text = this.schoolDetails.ArabicName
        ? " المدرسة الابتدائيّة " + this.schoolDetails.ArabicName
        : "................................................... : المدرسة الابتدائيّة";
      width = doc.getTextWidth(text);
      doc.text(text, 105 - width - 15, currentY);
      currentY += 8;
      text = ` ${this.schoolarYearName}  : السنة الدراسيّة`;
      width = doc.getTextWidth(text);
      doc.text(text, 105 - width - 15, currentY);
      currentY += 3;
      console.info("this to set Y of bg1.png", currentY);
      // ending header line
      doc.setDrawColor(52, 172, 215);
      doc.setLineWidth(0.8);
      doc.line(0, currentY, pdf_width, currentY);
      currentY += 5;

      let studentLabel =
        this.bulletin.gender === "male" ? " : التلميذ" : " : التلميذة";

      // student name
      doc.setFont("Amiri", "normal");
      doc.setFontSize(12);
      doc.setTextColor(99, 87, 91);
      text = studentLabel;
      width = doc.getTextWidth(text);
      doc.text(text, pdf_width - width - 12, currentY);

      text = this.bulletin.fullName;
      doc.setFont("Amiri", "Bold");
      doc.setFontSize(13);
      let width2 = doc.getTextWidth(text);

      doc.text(text, pdf_width - width - width2 - 12, currentY);
      doc.setFont("Amiri", "normal");
      doc.setFontSize(12);

      // student classroom
      text = " : القسم";
      doc.setTextColor(99, 87, 91);
      width = doc.getTextWidth(text);
      doc.text(text, pdf_width / 2 - width, currentY);
      text = this.bulletin.classroomName;
      width2 = doc.getTextWidth(text);
      doc.text(text, pdf_width / 2 - width - width2, currentY);

      // Number of inscribers in classroom
      if (this.showNbrStudents) {
        text = String(this.bulletin.nbInscriped);
        doc.text(text, 10, currentY);
        width = doc.getTextWidth(text);
        text = " :عدد التلاميذ المرسّمين";
        doc.setTextColor(99, 87, 91);
        doc.text(text, width + 10, currentY);
      }

      
      if (this.showNbrStudents && this.showUniqueIDen) currentY += 7.5

      if(this.showUniqueIDen){
        // label        
        text = " :المعرف الوحيد",
        width = doc.getTextWidth(text);
        let uniqueIdX = this.showNbrStudents? pdf_width - width - 12 : width + 10
        doc.text(text, uniqueIdX, currentY);
        // uniqueId
        text = String(this.bulletin.uniqueId || "--");
        uniqueIdX = this.showNbrStudents? pdf_width - width - doc.getTextWidth(text) - 12 : 10
        doc.setTextColor(99, 87, 91);
        
        doc.text(text,uniqueIdX, currentY);
      }      

      // title (نتائج نهائية)
      doc.setFillColor(180, 217, 233);
      this.roundRect(
        ctx,
        10,
        55,
        190,
        15,
        { upperRight: 15 },
        true,
        true,
        [187, 217, 233]
      );
      doc.setFont("PT Bold Heading", "Bold");
      doc.setFontSize(22);
      text = "النتائج النهائية";
      doc.setTextColor(51, 171, 214);
      width = doc.getTextWidth(text);
      doc.text(text, 107.5 - width / 2, 65);

      // trimester 1
      doc.setFillColor(182, 217, 235);
      doc.setDrawColor(51, 171, 214);
      this.roundRect(
        ctx,
        155.2,
        78.3,
        45.5,
        12,
        { upperRight: 12 },
        true,
        true,
        [51, 171, 214]
      );
      doc.setFillColor(0xff, 0xff, 0xff);
      doc.setLineWidth(0.4);
      doc.rect(120, 78, 35, 12, "FD");
      doc.setFont("Amiri", "Bold");
      doc.setFontSize(14);
      doc.setTextColor(51, 171, 214);
      text = "معدل الثّلاثي الأول";
      width = doc.getTextWidth(text);
      doc.text(text, 178 - width / 2, 85);
      doc.setTextColor(67, 62, 63);
      text = this.bulletin.moyenneOne;
      width = doc.getTextWidth(text);
      doc.text(text, 137 - width / 2, 85);

      // trimester 2
      doc.setFillColor(182, 217, 235);
      doc.setDrawColor(51, 171, 214);
      doc.setLineWidth(0.4);
      doc.rect(155, 90, 46, 12, "FD");
      doc.setFillColor(0xff, 0xff, 0xff);
      doc.rect(120, 90, 35, 12, "FD");
      doc.setFont("Amiri", "Bold");
      doc.setFontSize(14);
      doc.setTextColor(51, 171, 214);
      text = "معدل الثّلاثي الثّاني";
      width = doc.getTextWidth(text);
      doc.text(text, 178 - width / 2, 97);
      doc.setTextColor(67, 62, 63);
      text = this.bulletin.moyenneTwo;
      width = doc.getTextWidth(text);
      doc.text(text, 137 - width / 2, 97);

      // trimester 3
      doc.setFillColor(182, 217, 235);
      doc.setDrawColor(51, 171, 214);
      doc.setLineWidth(0.4);
      doc.rect(155, 102, 46, 12, "FD");
      doc.setFillColor(0xff, 0xff, 0xff);
      doc.rect(120, 102, 35, 12, "FD");
      doc.setFont("Amiri", "Bold");
      doc.setFontSize(14);
      doc.setTextColor(51, 171, 214);
      text = "معدل الثّلاثي الثّالث";
      width = doc.getTextWidth(text);
      doc.text(text, 178 - width / 2, 109);
      doc.setTextColor(67, 62, 63);
      text = this.bulletin.moyenneThree;
      width = doc.getTextWidth(text);
      doc.text(text, 137 - width / 2, 109);

      // annual moyenne
      doc.setFillColor(49, 125, 175);
      this.roundRect(
        ctx,
        77,
        78.3,
        35,
        12,
        { upperRight: 12 },
        true,
        true,
        [51, 171, 214]
      );
      doc.setFillColor(0xff, 0xff, 0xff);
      doc.setDrawColor(51, 171, 214);
      doc.setLineWidth(0.4);
      doc.rect(76.7, 90.3, 35.5, 24, "FD");
      doc.setFont("Amiri", "Bold");
      doc.setFontSize(14);
      text = "المعدل السنوي";
      width = doc.getTextWidth(text);
      doc.setTextColor(0xff, 0xff, 0xff);
      doc.text(text, 93 - width / 2, 86);
      doc.setTextColor(67, 62, 63);
      doc.setFontSize(16);
      text = this.bulletin.finalMoyenne;
      width = doc.getTextWidth(text);
      doc.text(text, 95 - width / 2, 102);

      // max annual moyenne
      doc.setFillColor(182, 217, 235);
      doc.setDrawColor(51, 171, 214);
      doc.setLineWidth(0.4);
      doc.rect(43, 78.3, 32, 12, "FD");
      doc.setFillColor(0xff, 0xff, 0xff);
      doc.rect(43, 90.3, 32, 24, "FD");
      doc.setFont("Amiri", "Bold");
      doc.setFontSize(12);
      doc.setTextColor(51, 171, 214);
      text = "أعلى\nمعدل سنوي بالقسم";
      width = doc.getTextWidth(text);
      doc.text(text, 77 - width / 2, 83, "center");
      doc.setTextColor(67, 62, 63);
      doc.setFontSize(16);
      text = this.bulletin.maxFinalMoyenne;
      width = doc.getTextWidth(text);
      doc.text(text, 60 - width / 2, 102);

      // min annual moyenne
      doc.setFillColor(182, 217, 235);
      doc.setDrawColor(51, 171, 214);
      doc.setLineWidth(0.4);
      doc.rect(10, 78.3, 31, 12, "FD");
      doc.setFillColor(0xff, 0xff, 0xff);
      doc.rect(10, 90.3, 31, 24, "FD");
      doc.setFont("Amiri", "Bold");
      doc.setFontSize(12);
      doc.setTextColor(51, 171, 214);
      text = "أدنى\nمعدل سنوي بالقسم";
      width = doc.getTextWidth(text);
      doc.text(text, 43 - width / 2, 83, "center");
      doc.setTextColor(67, 62, 63);
      doc.setFontSize(16);
      text = this.bulletin.minFinalMoyenne;
      width = doc.getTextWidth(text);
      doc.text(text, 25 - width / 2, 102);

      //council decision
      let councilY = 125;
      doc.setFillColor(0xff, 0xff, 0xff);
      doc.rect(10, councilY + 5, 190, 35, "FD");
      doc.setFillColor(182, 217, 235);
      this.roundRect(
        ctx,
        70,
        councilY,
        70,
        11,
        { upperRight: 11 },
        true,
        true,
        [51, 171, 214]
      );
      doc.setFont("Amiri", "Bold");
      doc.setFontSize(16);
      doc.setTextColor(51, 171, 214);
      text = "قرار مجلس القسم";
      width = doc.getTextWidth(text);
      doc.text(text, 120 - width / 2, councilY + 6, "center");
      doc.setTextColor(67, 62, 63);
      doc.setFontSize(16);
      text = this.bulletin.decisionConseil || "--";
      width = doc.getTextWidth(text);
      doc.text(text, 105 - width / 2, councilY + 23);

      // teachers list
      // teachers list - signs
      let teachersY = 175;
      let teachersWidth = 26.5;
      if (this.selectedTeachers.length > 3)
        teachersWidth += 8.45 * (this.selectedTeachers.length - 3) + 0.5;
      doc.setFillColor(182, 217, 235);
      this.roundRect(
        ctx,
        10.2,
        teachersY + 0.5,
        59.5,
        9,
        { upperRight: 9 },
        true,
        true,
        [51, 171, 214]
      );
      doc.setFillColor(0xff, 0xff, 0xff);
      doc.setLineWidth(0.4);
      doc.rect(10, teachersY + 10, 60, teachersWidth, "FD");
      doc.setFont("Amiri", "Bold");
      doc.setFontSize(15);
      doc.setTextColor(51, 171, 214);
      text = "الإمضاء";
      width = doc.getTextWidth(text);
      doc.text(text, 42 - width / 2, teachersY + 6, "center");

      // teachers list - teachers rect
      doc.setFillColor(182, 217, 235);
      this.roundRect(
        ctx,
        70.2,
        teachersY + 0.5,
        129.5,
        9,
        { upperRight: 9 },
        true,
        true,
        [51, 171, 214]
      );
      doc.setFillColor(0xff, 0xff, 0xff);
      doc.setLineWidth(0.4);
      doc.rect(70, teachersY + 10, 130, teachersWidth, "FD");
      doc.setFont("Amiri", "normal");
      doc.setFontSize(15);
      doc.setTextColor(51, 171, 214);
      text = "المدرّسون";
      width = doc.getTextWidth(text);
      doc.text(text, 140 - width / 2, teachersY + 6.5, "center");
      doc.setTextColor(67, 62, 63);
      doc.setFontSize(12);

      // teachers list - table
      const teacherNames = this.selectedTeachers.map((teacherId) => {
        const teacher = this.teachers.find((t) => t._id === teacherId);
        return teacher ? teacher.fullName : "";
      });

      const body = [
        ["", ""],
        ["", ""],
        ["", ""],
      ];
      for (let i = 0; i < teacherNames.length; i++) {
        if (body[i]) body[i][1] = teacherNames[i];
        else body.push(["", teacherNames[i]]);
      }
      doc.autoTable({
        startY: teachersY + 10,
        theme: "grid",
        styles: {
          font: "Amiri",
          halign: "center",
          valign: "middle",
          fontStyle: "normal",
          fontSize: 13,
          lineColor: [182, 217, 235],
          lineWidth: 0.1,
        },
        cellPadding: 0,
        body,
        margin: { left: 10.2 },
        didDrawPage: function (data) {
          // Reseting top margin. The change will be reflected only after print the first page.
          data.settings.margin.top = 10;
        },
        columnStyles: {
          0: { cellWidth: 60 },
          1: { cellWidth: 129.7 },
        },
      });

      //headmaster
      let headmasterY = 230 + (teachersWidth - 37);
      doc.setFillColor(0xff, 0xff, 0xff);
      doc.rect(10, headmasterY + 5, 190, 45, "FD");
      doc.setFillColor(182, 217, 235);
      this.roundRect(
        ctx,
        70,
        headmasterY,
        70,
        11,
        { upperRight: 11 },
        true,
        true,
        [51, 171, 214]
      );
      doc.setFont("Amiri", "Bold");
      doc.setFontSize(16);
      doc.setTextColor(51, 171, 214);
      text = "مدير)ة( المدرسة";
      width = doc.getTextWidth(text);
      doc.text(text, 120 - width / 2, headmasterY + 6, "center");
      // student name
      doc.setFont("Amiri", "normal");
      doc.setFontSize(12);
      doc.setTextColor(99, 87, 91);
      text = " : الإسم و اللقب";
      width = doc.getTextWidth(text);
      doc.text(text, pdf_width - width - 12, headmasterY + 25);
      doc.setFontSize(14);
      text = this.schoolDetails.headMaster;
      doc.text(text, 173, headmasterY + 25, "right");

      if (this.showDate) {
        doc.text(
          moment(this.bulletinDate || new Date()).format("DD/MM/YYYY"),
          125,
          headmasterY + 45,
          "right"
        );
      }
      //stamp
      if (this.showStamp && stampImage && stampImage.src) {
        try {
          const stampSize = 30 * (this.stampScale || 1);
          doc.addImage(
            stampImage,
            "PNG",
            20,
            headmasterY + 17,
            stampSize,
            stampSize
          );
        } catch (e) {}
      }
      //end stamp

      this.$emit("printLoading", false);
      let typeLabel = "";
      if (this.type === "MP") typeLabel = "Pédagogique";
      if (this.type === "MT") typeLabel = "Pilote";
      if (this.type === "MS") typeLabel = "Spécifique";
      doc.save(`Bulletin Annuel ${typeLabel} ${this.bulletin.fullName}.pdf`);
    },
    waitLoadingImage(image) {
      return new Promise((res, rej) => {
        image.onload = (t) => {
          res();
        };
        image.onerror = (e) => {
          rej();
        };
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },

    roundRect(
      ctx,
      x,
      y,
      width,
      height,
      radius,
      fill,
      stroke,
      border = [70, 187, 239]
    ) {
      const cornerRadius = {
        upperLeft: 0,
        upperRight: 0,
        lowerLeft: 0,
        lowerRight: 0,
      };
      if (typeof stroke == "undefined") {
        stroke = true;
      }
      if (typeof radius === "object") {
        for (const side in radius) {
          cornerRadius[side] = radius[side];
        }
      }

      ctx.lineWidth = 1;
      ctx.strokeStyle = `rgb(${border[0]}, ${border[1]}, ${border[2]})`;

      ctx.beginPath();
      ctx.moveTo(x + cornerRadius.upperLeft, y);
      ctx.lineTo(x + width - cornerRadius.upperRight, y);
      ctx.quadraticCurveTo(
        x + width,
        y,
        x + width,
        y + cornerRadius.upperRight
      );
      ctx.lineTo(x + width, y + height - cornerRadius.lowerRight);
      ctx.quadraticCurveTo(
        x + width,
        y + height,
        x + width - cornerRadius.lowerRight,
        y + height
      );
      ctx.lineTo(x + cornerRadius.lowerLeft, y + height);
      ctx.quadraticCurveTo(
        x,
        y + height,
        x,
        y + height - cornerRadius.lowerLeft
      );
      ctx.lineTo(x, y + cornerRadius.upperLeft);
      ctx.quadraticCurveTo(x, y, x + cornerRadius.upperLeft, y);
      ctx.closePath();
      if (stroke) {
        ctx.stroke();
      }
      if (fill) {
        ctx.fill();
      }
    },
  },
};
</script>
